import { render } from "./SelectAction.vue?vue&type=template&id=18100698&ts=true"
import script from "./SelectAction.vue?vue&type=script&lang=ts"
export * from "./SelectAction.vue?vue&type=script&lang=ts"

import exportComponent from "/root/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__